import React from "react"
import RadioGroup from "../../../RadioGroup/RadioGroup"
import MultiSelectDropdown from "../../../MultiSelectDropdown/MultiSelectDropdown"
import SearchInputV2 from "../../../SearchInputV2/SearchInputV2"
import InputTag from "../../../Input/InputTag"
import Chargers from "./Chargers"
import FileUploader from "../../../../pages/Projects/features/RaiseTicketForm/common/FileUploader/FileUploader"
import { FormPageProps } from "../.."
import styles from "../../RaiseTicketForm.module.scss"
import error_mark from "../../../../assets/images/error_mark.svg"
import { useSoloSurveyForm } from "./useSoloSurvey"

const SoloSurvey = (props: FormPageProps) => {
    const { formik, minDateFormatted, timeOfDayOptions, dealDoneByUsersList } = useSoloSurveyForm(props?.handleNextStep)

    const { values, handleChange, setFieldValue, handleSubmit, errors, touched, handleBlur } = formik

    return (
        <form onSubmit={handleSubmit}>
            <div className={styles.page_container} style={{ maxHeight: 500, overflow: "auto" }}>
                <div className={styles.page_section}>
                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className="section_header">Project Name*</div>
                            <SearchInputV2
                                placeholder="Enter Project Name"
                                type="text"
                                value={values.project_name}
                                onSearch={(val: any) => setFieldValue("project_name", val)}
                                height="44px"
                                error={!!formik.touched.project_name && !!formik.errors.project_name}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                        <div className="width-100p">
                            <div className="section_header">Business POC*</div>
                            <MultiSelectDropdown
                                title="Select Business POC"
                                options={dealDoneByUsersList?.map((category: any) => {
                                    return { id: category?.id, title: category?.name }
                                })}
                                id="business_poc"
                                selectionType="single"
                                selectedOptions={values.business_poc ? [values.business_poc] : []}
                                onSelect={(val: any) => setFieldValue("business_poc", val)}
                                height="44px"
                                error={!!formik.errors.business_poc && !!formik.touched.business_poc}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                    </div>
                    <Chargers formik={formik} />

                    <div className="section_header">Visit By*</div>
                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <InputTag
                                placeholder="Select a date"
                                type="date"
                                useCustomDate={true}
                                name="visit_by_date"
                                value={values.visit_by_date}
                                min={minDateFormatted}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputstyle={{
                                    height: "44px",
                                    border:
                                        touched.visit_by_date && errors.visit_by_date
                                            ? "1px solid rgb(252, 68, 30)"
                                            : "",
                                }}
                            />
                        </div>
                        <div className="width-100p">
                            <MultiSelectDropdown
                                title="Time of day"
                                options={timeOfDayOptions}
                                id="time"
                                selectionType="single"
                                selectedOptions={values.visit_by_time ? [values.visit_by_time] : []}
                                onSelect={(val: any) => setFieldValue("visit_by_time", val)}
                                height="44px"
                                error={formik.errors.visit_by_time ? true : false}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                    </div>

                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className={styles.section_header}>Spot Images*</div>
                            <FileUploader
                                name="spot_image"
                                ticket_id=""
                                size="lg"
                                accept="image/png,image/jpeg"
                                onChange={e => setFieldValue("spot_image", e)}
                                onUpload={() => {}}
                                title="Upload Images"
                                total={5}
                                uploadedCount={values.spot_image?.length || 0}
                                multiple
                                error={touched.spot_image && Boolean(errors.spot_image)}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                        <div className="width-100p">
                            <div className={styles.section_header}>Total Load Available (in KW)*</div>
                            <SearchInputV2
                                placeholder="Enter Load"
                                type="number"
                                value={values.load_available}
                                onSearch={(val: any) => setFieldValue("load_available", val)}
                                height="44px"
                                error={!!formik.touched.load_available && !!formik.errors.load_available}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                    </div>

                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className={styles.section_header}>Upload Electricity Bill*</div>
                            <FileUploader
                                name="electricity_bill"
                                ticket_id=""
                                size="lg"
                                onChange={e => setFieldValue("electricity_bill", e)}
                                onUpload={() => {}}
                                title="Upload File"
                                total={1}
                                uploadedCount={values.electricity_bill?.length || 0}
                                error={touched.electricity_bill && Boolean(errors.electricity_bill)}
                                showError={formik.submitCount > 0}
                            />
                        </div>

                        <div className="width-100p">
                            <div className={styles.section_header}>
                                Select Foundation Type*{" "}
                                {formik.errors.foundation_type && <img src={error_mark} alt="" />}
                            </div>
                            <RadioGroup
                                options={[
                                    { id: 0, title: "Wall" },
                                    { id: 1, title: "Stand" },
                                ]}
                                onSelect={(value: any) => setFieldValue("foundation_type", value)}
                                value={values.foundation_type}
                            />
                        </div>
                    </div>

                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className={styles.section_header}>
                                Connection Type* {formik.errors.connection_type && <img src={error_mark} alt="" />}
                            </div>
                            <RadioGroup
                                options={[
                                    { id: 0, title: "3 Phase" },
                                    { id: 1, title: "Single Phase" },
                                ]}
                                onSelect={(value: any) => setFieldValue("connection_type", value)}
                                value={values.connection_type}
                            />
                        </div>
                        <div className="width-100p">
                            {/* <div className={styles.section_header}>Estimated Survey Completion Date</div>
                            <InputTag
                                placeholder="Select a date"
                                type="date"
                                name="survey_completion_date"
                                value={values.survey_completion_date}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputstyle={{
                                    height:
                                        touched.survey_completion_date && errors.survey_completion_date
                                            ? "42px"
                                            : "44px",
                                    border:
                                        touched.survey_completion_date && errors.survey_completion_date
                                            ? "1px solid rgb(252, 68, 30)"
                                            : "",
                                }}
                            /> */}
                        </div>
                    </div>

                    <div className={styles.form_title}>LOAD AVAILABLE</div>
                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className={styles.section_header}>Demand Load (in KWH)*</div>
                            <SearchInputV2
                                placeholder="Enter Demand Load"
                                type="number"
                                value={values.demand_load}
                                onSearch={(val: any) => setFieldValue("demand_load", val)}
                                height="44px"
                                error={!!formik.touched.demand_load && !!formik.errors.demand_load}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                        <div className="width-100p">
                            <div className={styles.section_header}>Sanctioned Load (In KWH)*</div>
                            <SearchInputV2
                                placeholder="Enter Sanctioned Load"
                                type="number"
                                value={values.sanctioned_load}
                                onSearch={(val: any) => setFieldValue("sanctioned_load", val)}
                                height="44px"
                                error={!!formik.touched.sanctioned_load && !!formik.errors.sanctioned_load}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                        {/* <div className="width-100p">
                            <div className={styles.section_header}>Parking Slots*</div>
                            <SearchInputV2
                                placeholder="Enter Parking Slots"
                                value={values.parking_slot}
                                onSearch={(val: any) => setFieldValue("parking_slot", val)}
                                height="44px"
                                error={!!formik.touched.parking_slot && !!formik.errors.parking_slot}
                                showError={formik.submitCount > 0}
                            />
                        </div> */}
                    </div>
                    {/* <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className={styles.section_header}>Remarks</div>
                            <SearchInputV2
                                placeholder="Enter Remarks"
                                value={values.remarks}
                                onSearch={(val: any) => setFieldValue("remarks", val)}
                                height="44px"
                            />
                        </div>
                        <div className="width-100p"></div>
                    </div> */}
                </div>
            </div>

            <footer className="raise-ticket-form__footer">
                <button
                    type="button"
                    className="raise-ticket-form__footer-button cancel-btn"
                    onClick={props?.handleCloseForm}
                >
                    Cancel
                </button>
                <button type="submit" className="raise-ticket-form__footer-button next-btn">
                    Next
                </button>
            </footer>
        </form>
    )
}

export default SoloSurvey
